// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3JfjN","left":"StickyBox_left__3vrFo","right":"StickyBox_right__5g2y5"};